import type { FindOperator } from "../FindOperator"
import { EqualOperator } from "../EqualOperator"

/**
 * Find Options Operator.
 * This operator is handy to provide object value for non-relational properties of the Entity.
 *
 * @example
 * { someField: Equal("value") }
 *
 * @example
 * { uuid: Equal(new UUID()) }
 *
 * @param value
 */
export function Equal<T>(value: T | FindOperator<T>) {
    return new EqualOperator(value)
}
